import { memo } from 'react'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface iChatMessageContentsProps {
  message: string
}

const ChatMessageContents = (props: iChatMessageContentsProps) => {
  const renderers = {
    image: ({ src, alt, title }: { src: string, alt: string, title: string }) => (
      <img
        src={src}
        alt={alt}
        title={title}
        style={{ maxWidth: '100%', height: 'auto' }}
      />
    ),
  }

  return (
    <ReactMarkdown
      source={props.message}
      plugins={[remarkGfm]}
      renderers={renderers}
    />
  )
}

export default memo(ChatMessageContents)
